'use strict';

let recaptcha = require('recaptcha/recaptcha/recaptcha');

let OPEN_CLASS = 'is-notify-me-open';
let HIDDEN_CLASS = 'notify-me-modal--hidden';
let EMAIL_INPUT = 'input[name="email"]';
let FOCUSABLE = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
let EMAIL_PATTERN = /^[\w.%+-]+@[\w.-]+\.[\w]{2,6}$/;

function setOpen(root, show) {
	if (!root) {
		return;
	}
	if (show) {
		root.removeAttribute('hidden');
		root.setAttribute('aria-hidden', 'false');
		root.classList.remove(HIDDEN_CLASS);
		document.documentElement.classList.add(OPEN_CLASS);
		return;
	}
	root.setAttribute('hidden', '');
	root.setAttribute('aria-hidden', 'true');
	root.classList.add(HIDDEN_CLASS);
	document.documentElement.classList.remove(OPEN_CLASS);
}

function getModal(id) {
	return id ? document.getElementById(id) : null;
}

function focusFirst(root) {
	let dialog = root.querySelector('.notify-me-modal__dialog');
	let first = dialog ? dialog.querySelector(EMAIL_INPUT) || dialog.querySelector(FOCUSABLE) : null;
	try {
		(first || dialog || root).focus();
	} catch (e) {
		// Ignore focus errors on hidden or detached nodes.
	}
}

function clearFormState($form) {
	$form.find('[data-notify-me-error-message]').text('');
	$form.find('[data-notify-me-error]').attr('hidden', 'hidden');
	$form.find('[data-notify-me-status]').text('').removeClass('notify-me-form__status--success notify-me-form__status--error');
	$form.find(EMAIL_INPUT).removeAttr('aria-invalid');
}

function resetSuccessState(root) {
	let $root = $(root);
	$root.find('[data-notify-me-title]').text($root.attr('data-notify-me-default-title'));
	$root.find('[data-notify-me-description]').text($root.attr('data-notify-me-default-description'));
	$root.find('[data-notify-me-form]').removeAttr('hidden');
	$root.find('[data-notify-me-success]').attr('hidden', 'hidden');
}

function setSuccess($form) {
	let $root = $form.closest('[data-notify-me-modal]');
	$root.find('[data-notify-me-title]').text($root.attr('data-notify-me-success-title'));
	$root.find('[data-notify-me-description]').text($root.attr('data-notify-me-success-description'));
	$form.attr('hidden', 'hidden');
	$root.find('[data-notify-me-success]').removeAttr('hidden');
}

function setError($form, message) {
	$form.find('[data-notify-me-error-message]').text(message);
	$form.find('[data-notify-me-error]').removeAttr('hidden');
	$form.find('[data-notify-me-status]').text('').removeClass('notify-me-form__status--success notify-me-form__status--error');
	$form.find(EMAIL_INPUT).attr('aria-invalid', 'true').trigger('focus');
}

function isEmailValid($form) {
	return EMAIL_PATTERN.test(($form.find(EMAIL_INPUT).val() || '').trim());
}

function setStatus($form, message, isError) {
	$form
		.find('[data-notify-me-status]')
		.text(message)
		.toggleClass('notify-me-form__status--success', !isError)
		.toggleClass('notify-me-form__status--error', !!isError);
}

function openModal(trigger) {
	let id = trigger.getAttribute('data-notify-me-trigger');
	let root = getModal(id);
	if (!root) {
		return;
	}
	root.notifyMeOpener = trigger;
	let pid = trigger.getAttribute('data-notify-me-pid');
	if (pid) {
		let pidField = root.querySelector('[data-notify-me-pid-field]');
		if (pidField) {
			pidField.value = pid;
		}
	}
	resetSuccessState(root);
	clearFormState($(root).find('[data-notify-me-form]').first());
	setOpen(root, true);
	if (window.lavazzaGtm && window.lavazzaGtm.ecommerce) {
		window.lavazzaGtm.ecommerce.trackNotifyMeOpen({ trigger: trigger });
	}
	if (!root.notifyMeRecaptchaInitialized) {
		let placeholder = root.querySelector('[data-recaptcha-url]');
		if (placeholder) {
			placeholder.classList.add('recaptcha');
		}
		recaptcha.init(root);
		placeBadgeInModal(root);
		root.notifyMeRecaptchaInitialized = true;
	} else {
		placeBadgeInModal(root);
	}
	focusFirst(root);
}

function placeBadgeInModal(root) {
	let host = root.querySelector('.notify-me-form__recaptcha');
	if (!host) {
		return;
	}

	function moveBadge() {
		let badge = document.querySelector('.grecaptcha-badge');
		if (badge && badge.parentNode !== host) {
			host.appendChild(badge);
			return true;
		}
		return !!host.querySelector('.grecaptcha-badge');
	}

	if (moveBadge() || root.notifyMeBadgeObserver) {
		return;
	}

	let observer = new MutationObserver(function () {
		if (moveBadge()) {
			observer.disconnect();
			root.notifyMeBadgeObserver = null;
		}
	});
	root.notifyMeBadgeObserver = observer;
	observer.observe(document.body, { childList: true, subtree: true });
}

function resetRecaptcha(root) {
	let $root = $(root);
	let api = typeof grecaptcha !== 'undefined' ? grecaptcha : null;

	$root.find('[name="g-recaptcha-response"]').val('');

	if (api && typeof api.reset === 'function') {
		try {
			api.reset();
		} catch (e) {
			// Ignore reset errors when Google has not created a widget instance yet.
		}
	}
}

function closeModal(root) {
	if (!root) {
		return;
	}
	resetRecaptcha(root);
	setOpen(root, false);
	if (root.notifyMeOpener) {
		try {
			root.notifyMeOpener.focus();
		} catch (e) {
			// Ignore focus restore failures.
		}
	}
}

function trapFocus(e, root) {
	if (e.key !== 'Tab') {
		return;
	}
	let focusable = Array.prototype.slice.call(root.querySelectorAll(FOCUSABLE)).filter(function (node) {
		return !node.disabled && node.offsetParent !== null;
	});
	if (!focusable.length) {
		return;
	}
	let first = focusable[0];
	let last = focusable[focusable.length - 1];
	if (e.shiftKey && document.activeElement === first) {
		e.preventDefault();
		last.focus();
	} else if (!e.shiftKey && document.activeElement === last) {
		e.preventDefault();
		first.focus();
	}
}

function serializeWithFallbackToken($form) {
	let serialized = $form.serializeArray();
	let hasCsrf = serialized.some(function (field) {
		return field.name === 'csrf_token' || field.name.indexOf('csrf') !== -1;
	});
	if (!hasCsrf) {
		let $pageToken = $('input[name="csrf_token"]').first();
		if ($pageToken.length) {
			serialized.push({ name: $pageToken.attr('name'), value: $pageToken.val() });
		}
	}
	return $.param(serialized);
}

function trackNotifyMeSubmitSuccess($form) {
	let $root = $form.closest('[data-notify-me-modal]');
	let pid = $root.find('[data-notify-me-pid-field]').val() || '';
	if (window.lavazzaGtm && window.lavazzaGtm.ecommerce) {
		window.lavazzaGtm.ecommerce.trackNotifyMeSubmit({
			pid: pid,
			trigger: $root.get(0) && $root.get(0).notifyMeOpener
		});
	}
}

function resetRecaptchaIfNeeded(newv3) {
	if (newv3.length > 0) {
		return;
	}
	if (typeof grecaptcha !== 'undefined' && grecaptcha && grecaptcha.reset) {
		grecaptcha.reset();
	}
}

function handleNotifyMeSubmitSuccess($form, response, newv3) {
	if (response && response.success) {
		setSuccess($form);
		trackNotifyMeSubmitSuccess($form);
		return;
	}
	if (response && response.fieldErrors && response.fieldErrors.email) {
		setError($form, response.fieldErrors.email);
		resetRecaptchaIfNeeded(newv3);
		return;
	}
	setStatus($form, response && response.message ? response.message : '', true);
}

function submitForm(e) {
	e.preventDefault();
	let $form = $(this);
	let $submitButton = $form.find('button[type="submit"]').first();
	let timeout = 0;
	let newv3 = $('[data-newv3]') || '';

	clearFormState($form);

	if (!isEmailValid($form)) {
		setError($form, $form.attr('data-email-error') || '');
		return;
	}

	if (newv3.length > 0) {
		timeout = 700;
		$('body').trigger('recaptcha:v3', {
			thisBtn: $submitButton,
		});
	}

	$submitButton.prop('disabled', true);

	window.setTimeout(function () {
		$.ajax({
			url: $form.attr('action'),
			method: 'POST',
			global: false,
			data: serializeWithFallbackToken($form),
			success: function (response) {
				handleNotifyMeSubmitSuccess($form, response, newv3);
			},
			error: function () {
				setStatus($form, $form.attr('data-generic-error') || '', true);
			},
			complete: function () {
				$submitButton.prop('disabled', false);
			},
		});
	}, timeout);
}
function syncTileGlobalLinkMessageClass($container) {
	let $link = $container.find('.product-tile__global-link');
	if (!$link.length) {
		return;
	}
	let hasNotifyMessage = $container.find('.notify-me-unavailable-message').not('.d-none').length > 0;
	let hasMultiplePurchaseMessage = $container.find('.product-multiple-purchase-disclaimer-container').length > 0;
	$link.toggleClass('large-message', hasNotifyMessage !== hasMultiplePurchaseMessage);
	$link.toggleClass('extralarge-message', hasNotifyMessage && hasMultiplePurchaseMessage);
}

function updateProductState(product, $container) {
	if (!product || !product.notifyMe || !$container || !$container.length) {
		return;
	}
	let enabled = !!product.notifyMe.enabled;
	let notifyMePid = product.selectedProductId || product.id;
	$container.attr('data-notify-me-enabled', enabled);
	$container.attr('data-notify-me-pid', notifyMePid);
	$container.toggleClass('product-detail--notify-me', enabled);
	$container.find('.product-tile__qty-atc').toggleClass('product-tile__qty-atc--notify-me', enabled);
	$container
		.find('.product-detail__quantity, .cart-and-ipay, .product-tile__add-to-cart')
		.toggleClass('d-none', enabled);
	$container
		.find('.product-qty-wrap')
		.filter(function () {
			return $(this).closest('.product-tile__quantity').length === 0;
		})
		.toggleClass('d-none', enabled);
	$container.find('.product-tile__quantity').removeClass('d-none');
	$container.find('.notify-me-cta').toggleClass('d-none', !enabled).attr('data-notify-me-pid', notifyMePid);
	$container.find('.notify-me-unavailable-message, .not-available__message').toggleClass('d-none', !enabled);
	$container.find('[data-notify-me-pid-field]').val(notifyMePid);
	syncTileGlobalLinkMessageClass($container);
}

module.exports = function initNotifyMe() {
	// Bound on document, so a single init covers tiles rendered by any page (PDP, PLP,
	// editorial carousels, …). Guard against multiple entry points double-binding the
	// form submit handler.
	if (window.__lvzNotifyMeInit) {
		return;
	}
	window.__lvzNotifyMeInit = true;

	$(document).on('click', '[data-notify-me-trigger]', function (e) {
		e.preventDefault();
		e.stopImmediatePropagation();
		openModal(this);
	});

	$(document).on('click', '[data-notify-me-close]', function (e) {
		e.preventDefault();
		closeModal(this.closest('[data-notify-me-modal]'));
	});

	$(document).on('click', '[data-notify-me-success-close]', function (e) {
		e.preventDefault();
		closeModal(this.closest('[data-notify-me-modal]'));
	});

	$(document).on('keydown', '[data-notify-me-modal]', function (e) {
		if (e.key === 'Escape') {
			e.preventDefault();
			closeModal(this);
			return;
		}
		trapFocus(e, this);
	});

	$(document).on('submit', '[data-notify-me-form]', submitForm);

	$(document).on('input', '[data-notify-me-form] ' + EMAIL_INPUT, function () {
		clearFormState($(this).closest('[data-notify-me-form]'));
	});

	$('body').on('product:afterAttributeSelect', function (e, payload) {
		if (!payload || !payload.data || !payload.data.product) {
			return;
		}
		updateProductState(payload.data.product, payload.container);
	});
};

module.exports.updateProductState = updateProductState;
